import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getDataWeatherData as getDataWeatherDataApi,
	getDataWeatherCurrent as getDataWeatherCurrentApi,
} from '../../helpers/data_weather/backend_helper';

export const getDataWeatherData = createAsyncThunk('holdings/getDataWeatherData', async (params) => {
	try {
		const response = getDataWeatherDataApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});


export const getDataWeatherCurrent = createAsyncThunk('holdings/getDataWeatherCurrent', async (code_siep) => {
	try {
		const response = getDataWeatherCurrentApi(code_siep);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

